// Define all public routes in the application
export const PUBLIC_ROUTES = [
  /^\/$/, // Home page
  /^\/about\/?$/, // About page
  /^\/features\/?$/, // Features page
  /^\/pricing\/?$/, // Pricing page
  /^\/compare\/.*$/, // Comparison pages
  /^\/blog\/?.*$/, // Blog pages
  /^\/login\/?$/, // Login page
  /^\/signup\/?$/, // Signup page
  /^\/privacy\/?$/, // Privacy policy
  /^\/terms\/?$/, // Terms of service
  /^\/maas\/?$/, // MaaS page
  /^\/ai-manifestation\/?$/, // AI Manifestation page
  /^\/ai-vision-board\/?$/, // AI Vision Board page
  /^\/payment-setup\/?$/, // Payment setup page
  /^\/auth\/.*$/, // OAuth callback routes
  /^\/unsubscribe\/?$/ // Email unsubscribe page
];

// Helper function to check if a path is a public route
export function isPublicRoute(path: string): boolean {
  return PUBLIC_ROUTES.some(pattern => pattern.test(path));
}

// Define all protected routes that require authentication
export const PROTECTED_ROUTES = [
  /^\/dashboard\/?.*$/, // Dashboard and all sub-routes
  /^\/journal\/?$/, // Journal page
  /^\/admin\/?.*$/ // Admin panel and all sub-routes
];

// Helper function to check if a path is a protected route
export function isProtectedRoute(path: string): boolean {
  return PROTECTED_ROUTES.some(pattern => pattern.test(path));
}